exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error{color:red;font-weight:700}.card-item{min-height:150px;background:#ececec;padding:10px;border-radius:10px;box-shadow:0 0 20px #ececec}.current-address{position:absolute;content:\"\";top:0;right:15px;width:100px;background:#2b303b;color:#fff!important;padding:5px;border-radius:0 5px 0 0}", ""]);

// exports
